// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1B4WX","clinicsSelect":"TableHeading_clinicsSelect__21VC4"};